

import { t } from "i18next";
import { ws } from "../../../utils/common";
import { isValidPassword, } from "../../../utils/validation";

export const changePasswordWS = async ({ newPassword, confirmPassword, oldPassword }) => {
    if (!newPassword || !confirmPassword || !oldPassword) {
        throw new Error(t("validation.compile_all_form"));
    }

    if (!isValidPassword(newPassword)) {
        throw new Error(t("validation.new_password_not_valid"));
    }

    if (!isValidPassword(oldPassword)) {
        throw new Error(t("validation.old_password_not_valid"));
    }

    if (confirmPassword !== newPassword) {
        throw new Error(t("validation.password_are_not_equal"));
    }

    const res = await ws(
        "PUT",
        process.env.REACT_APP_ENDPOINT + "user/change-password/",
        null,
        {
            old_password: oldPassword,
            new_password: newPassword,
        },
        true
    );

    if (res.error) {
        throw res.data;
    } else {
        return res.data;
    }
};
